import { ValidationMessage } from "sj-ui-toolkit/src/components";
import AudienceUsersList from "@/components/AudienceUsersList";
import type { DirectoryUserShape, StoredUser } from "@/api/assignments";
import type { AvailableUsersMap } from "@/hooks/useAvailableUsers";
import type { MutableRefObject } from "react";

interface TargetValues {
  users: StoredUser[];
  availableUsers: DirectoryUserShape[];
  allUsers?: Map<string, AvailableUsersMap>;
}

interface AssessmentAudienceProps {
  values: TargetValues;
  handleChange: (values: TargetValues) => void;
  newHireValue: boolean;
  onNewHireChange: (v: boolean) => void;
  showValidationMessages?: boolean;
  validationErrors?: { hasError?: boolean; message?: string };
  onSelectedUsersChange?: (users: DirectoryUserShape[]) => void;
  onAddUsersAndContinue?: MutableRefObject<(() => void) | null>;
  selectedUsersToAdd: DirectoryUserShape[];
  setSelectedUsersToAdd: (users: DirectoryUserShape[]) => void;
  selectedUsersToRemove: DirectoryUserShape[];
  setSelectedUsersToRemove: (users: DirectoryUserShape[]) => void;
}

export default function AssessmentAudience({
  values,
  handleChange,
  newHireValue,
  onNewHireChange,
  showValidationMessages,
  validationErrors,
  onSelectedUsersChange,
  onAddUsersAndContinue,
  selectedUsersToAdd,
  setSelectedUsersToAdd,
  selectedUsersToRemove,
  setSelectedUsersToRemove,
}: AssessmentAudienceProps) {
  return (
    <>
      <AudienceUsersList
        values={{
          users: values.users,
          availableUsers: values.availableUsers,
          allUsers: values.allUsers,
        }}
        handleChange={handleChange}
        newHireValue={newHireValue}
        handleNewHireChange={onNewHireChange}
        showNewHire
        onSelectedUsersChange={onSelectedUsersChange}
        onAddUsersAndContinue={onAddUsersAndContinue}
        selectedUsersToAdd={selectedUsersToAdd}
        setSelectedUsersToAdd={setSelectedUsersToAdd}
        selectedUsersToRemove={selectedUsersToRemove}
        setSelectedUsersToRemove={setSelectedUsersToRemove}
        entityType="Assessment"
        tableId="assessment"
      />
      {showValidationMessages && validationErrors?.hasError && (
        <div className="mt-2">
          <ValidationMessage severity="error" text={validationErrors.message} />
        </div>
      )}
    </>
  );
}
